export function releaseDetail() {
  const releaseDetail = document.querySelector('#releaseDetail');

  if(releaseDetail) {
    // aタグ取得
    const anchors = releaseDetail.querySelectorAll('a');
    anchors.forEach(anchor => {
      let href = anchor.href;
      if(href.includes('pdf')) { //href値にpdfの文字列が含まれている場合
        anchor.classList.add('c-txtLink--pdf');
        let icon = document.createElement('span');
        icon.classList.add('c-ico_pdf');
        anchor.appendChild(icon);
      }
    });
  }
}